<form fxLayout="column" [formGroup]="form" (ngSubmit)="submit()">
  <mat-form-field *ngIf="'title' | map: fieldEnabled : this | async" fxFlex>
    <mat-label>Title</mat-label>
    <pr-editor-input
      placeholder="Title"
      formControlName="title"
      [required]="true"
      [attr.cdkFocusInitial]="!locked() ? '' : null"
      [disabled]="locked()"
    />
  </mat-form-field>

  <mat-form-field *ngIf="'type' | map: fieldEnabled : this | async">
    <mat-label>Event Type</mat-label>
    <mat-select placeholder="Event Type" formControlName="type">
      @for (type of eventTypes$ | async; track type) {
        <mat-option [value]="type">
          {{ type | splitCamel | titlecase }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <ng-container *ngIf="isPreBlock$ | async">
    <div fxLayout="column" fxLayoutGap="8px">
      <mat-checkbox
        *ngIf="'isPublic' | map: fieldEnabled : this | async"
        formControlName="isPublic"
      >
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
          <span>Can be Booked Online</span>
          <mat-icon matTooltip="Allow this pre-block to be booked online">
            info
          </mat-icon>
        </div>
      </mat-checkbox>

      <div
        *ngIf="'allowedTreatmentCategories' | map: fieldEnabled : this | async"
        class="flex items-center gap-2"
      >
        <mat-form-field class="flex-1">
          <mat-label>Allowed Treatment Categories</mat-label>
          <mat-select
            formControlName="allowedTreatmentCategories"
            multiple
            [compareWith]="isSelectedNamedDocument"
          >
            <mat-option
              *ngFor="
                let category of globalStore.treatmentCategories$ | async;
                trackBy: trackByCategory
              "
              [value]="category.ref"
            >
              <div fxLayout="row" fxLayoutGap="8px">
                <div
                  fxFlex="8px"
                  [style.backgroundColor]="category.colour.value"
                ></div>
                <span>{{ category.name }}</span>
              </div>
            </mat-option>
          </mat-select>

          <mat-icon
            matIconSuffix
            matTooltip="Restrict which treatments can be booked by their treatment category"
          >
            info
          </mat-icon>
        </mat-form-field>

        <ng-container *ngrxLet="allowedCategoryColours$ as colours">
          <div
            *ngIf="colours.length > 1"
            class="mb-4 flex items-center gap-2"
            (click)="$event.preventDefault()"
          >
            <button
              class="sync-button opacity-70"
              mat-icon-button
              matTooltip="Revert to default"
              (click)="form.controls.colourOverride.reset()"
            >
              <mat-icon>sync</mat-icon>
            </button>
            <pt-event-colour-picker
              [colour]="defaultPreBlockColour$ | async"
              [palette]="colours"
              [disableOpacity]="true"
              (colourChanged)="form.controls.colourOverride.setValue($event)"
            />
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="canHaveSingleParticipant$ | async">
    <mat-form-field
      *ngIf="'staffSearch' | map: fieldEnabled : this | async"
      fxFlex
    >
      <mat-label>Participant</mat-label>
      <input
        #autoComplete="matAutocompleteTrigger"
        matInput
        placeholder="Add Participant"
        formControlName="staffSearch"
        [required]="true"
        [matAutocomplete]="auto"
        (click)="autoComplete.openPanel()"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        [autoActiveFirstOption]="true"
        [displayWith]="displayFn"
        (optionSelected)="addParticipant($event)"
      >
        <mat-option
          *ngFor="
            let staffer of staffSearchFilter.results$ | async;
            trackBy: trackByStaffer
          "
          [value]="staffer"
        >
          {{ staffer.user.name }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </ng-container>

  <ng-container *ngIf="isLeave$ | async; else meetingBreakSelectors">
    <div
      *ngIf="'eventStartDate' | map: fieldEnabled : this | async"
      fxFlex
      fxLayout="row"
      fxLayoutAlign="space-between center"
      fxLayoutGap="16px"
    >
      <mat-form-field fxFlex="50">
        <mat-label>Event Date</mat-label>
        <input
          matInput
          formControlName="eventStartDate"
          [matDatepicker]="eventStartDate"
          [required]="true"
          (focus)="eventStartDate.open()"
          (click)="eventStartDate.open()"
        />
        <mat-datepicker-toggle matIconSuffix [for]="eventStartDate" />
        <mat-datepicker #eventStartDate />
      </mat-form-field>

      <pr-date-selector
        fxFlex="50"
        placeholder="Start Time"
        formControlName="startTime"
        [timeTo]="form.controls.endTime.value"
        [required]="true"
      />
    </div>
    <div
      fxFlex
      fxLayout="row"
      fxLayoutAlign="space-between center"
      fxLayoutGap="16px"
    >
      <mat-form-field
        *ngIf="'eventEndDate' | map: fieldEnabled : this | async"
        fxFlex="50"
      >
        <mat-label>Event End Date</mat-label>
        <input
          matInput
          formControlName="eventEndDate"
          [matDatepicker]="eventEndDate"
          [min]="minimumEndDate$ | async"
          [required]="true"
          (focus)="eventEndDate.open()"
          (click)="eventEndDate.open()"
        />
        <mat-datepicker-toggle matIconSuffix [for]="eventEndDate" />
        <mat-datepicker #eventEndDate />
      </mat-form-field>
      <pr-date-selector
        *ngIf="'endTime' | map: fieldEnabled : this | async"
        fxFlex="50"
        placeholder="End Time"
        formControlName="endTime"
        [timeFrom]="form.controls.startTime.value"
        [required]="true"
      />
    </div>
  </ng-container>
  <ng-template #meetingBreakSelectors>
    <div
      fxFlex
      fxLayout="row"
      fxLayoutAlign="space-between center"
      fxLayoutGap="16px"
    >
      <mat-form-field
        *ngIf="'eventStartDate' | map: fieldEnabled : this | async"
        fxFlex="50"
      >
        <mat-label>Event Date</mat-label>
        <input
          matInput
          formControlName="eventStartDate"
          [matDatepicker]="eventStartDate"
          [required]="true"
          (focus)="eventStartDate.open()"
          (click)="eventStartDate.open()"
        />
        <mat-datepicker-toggle matIconSuffix [for]="eventStartDate" />
        <mat-datepicker #eventStartDate />
      </mat-form-field>

      <pr-date-selector
        *ngIf="'startTime' | map: fieldEnabled : this | async"
        fxFlex="25"
        placeholder="Start Time"
        formControlName="startTime"
        [timeTo]="form.controls.endTime.value"
        [required]="true"
      />

      <pr-date-selector
        *ngIf="'endTime' | map: fieldEnabled : this | async"
        fxFlex="25"
        placeholder="End Time"
        formControlName="endTime"
        [timeFrom]="form.controls.startTime.value"
        [required]="true"
      />
    </div>
  </ng-template>

  <mat-form-field *ngIf="'practice' | map: fieldEnabled : this | async">
    <mat-label>Event Location</mat-label>
    <mat-select
      formControlName="practice"
      [compareWith]="isSelectedNamedDocument"
      [required]="true"
    >
      <mat-option
        *ngFor="let practice of practices$ | async; trackBy: trackByPractice"
        [value]="practice"
      >
        {{ practice.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <ng-container *ngIf="canHaveMultipleParticipants$ | async">
    <ng-container *ngIf="'staffSearch' | map: fieldEnabled : this | async">
      <mat-form-field>
        <mat-label>Participants</mat-label>
        <input
          #autoComplete="matAutocompleteTrigger"
          matInput
          placeholder="Add Participants"
          formControlName="staffSearch"
          [matAutocomplete]="auto"
          (click)="autoComplete.openPanel()"
        />

        <mat-autocomplete
          #auto="matAutocomplete"
          [autoActiveFirstOption]="true"
          [displayWith]="displayFn"
          (optionSelected)="addParticipant($event)"
        >
          <ng-container *ngIf="staffSearchFilter.results$ | async as staff">
            <mat-option
              *ngFor="let staffer of staff; trackBy: trackByStaffer"
              [value]="staffer"
            >
              {{ staffer.user.name }}
            </mat-option>
          </ng-container>
        </mat-autocomplete>
      </mat-form-field>
      <mat-list
        *ngIf="participants$ | async as participants"
        fxFill
        class="participant-list"
      >
        <mat-list-item
          *ngFor="let participant of participants; trackBy: trackByParticipant"
        >
          <div fxFlex="10">
            <pt-user-icon
              [name]="participant.name"
              [src]="participant | profileImage$ | async"
              [diameter]="30"
            />
          </div>
          <div fxFlex="70">
            <span>{{ participant.name }}</span>
          </div>
          <div fxFlex fxLayout="row" fxLayoutAlign="end center">
            <button
              mat-icon-button
              type="button"
              (click)="removeParticipant(participant)"
            >
              <mat-icon>clear</mat-icon>
            </button>
          </div>
        </mat-list-item>
      </mat-list>
    </ng-container>
  </ng-container>

  <mat-form-field *ngIf="'notes' | map: fieldEnabled : this | async" fxFlex>
    <mat-label>Description</mat-label>
    <pr-content-editor
      formControlName="notes"
      placeholder="Add Event Description"
      [menuEnabled]="false"
      [disabled]="locked()"
    />
  </mat-form-field>

  <pr-tags-input
    *ngIf="'eventTags' | map: fieldEnabled : this | async"
    formControlName="eventTags"
    [tagCol]="tagCol$ | async"
    [tagType]="tagType"
    [disabled]="locked()"
  />

  @if ('locked' | map: fieldEnabled : this | async) {
    <div class="flex flex-row items-center gap-4">
      <mat-checkbox class="flex grow" formControlName="locked">
        <div
          class="flex flex-row items-center gap-1"
          matTooltip="Prevent other users from editing this event. Only {{
            creator()?.name ?? 'you'
          }} will be able to unlock or edit it."
          [matTooltipDisabled]="false"
        >
          <span>Lock Event</span>
          <mat-icon class="icon-xs opacity-50">info</mat-icon>
        </div>
      </mat-checkbox>
      @if (creator(); as lockedTo) {
        <div class="flex flex-row items-center gap-2">
          <div>Created by {{ lockedTo.name }}</div>
          <pt-user-icon
            [name]="lockedTo.name"
            [src]="creatorProfileImage$ | async"
            [diameter]="30"
          />
        </div>
      }
    </div>
  }
  @if (canBeBlocking$ | async) {
    <mat-checkbox
      *ngIf="'isBlocking' | map: fieldEnabled : this | async"
      formControlName="isBlocking"
    >
      <div
        class="flex flex-row items-center gap-1"
        matTooltip="Prevent other events being scheduled at the same time"
        [matTooltipDisabled]="false"
      >
        <span>Blocking Event</span>
        <mat-icon class="icon-xs opacity-50">info</mat-icon>
      </div>
    </mat-checkbox>
  }

  <button type="submit" hidden></button>
</form>
